var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 30,
    viewBox: "0 0 37 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "back-arrow-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.369629 15C0.369629 13.8165 1.33433 12.8571 2.52435 12.8571H34.8452C36.0352 12.8571 36.9999 13.8165 36.9999 15C36.9999 16.1835 36.0352 17.1429 34.8452 17.1429H2.52435C1.33433 17.1429 0.369629 16.1835 0.369629 15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8218 29.3724C13.9803 30.2092 12.616 30.2092 11.7745 29.3724L1.89343 19.5457C-0.630988 17.0352 -0.630981 12.9648 1.89343 10.4543L11.7745 0.627632C12.616 -0.209207 13.9803 -0.209207 14.8218 0.627632C15.6632 1.46447 15.6632 2.82125 14.8218 3.65809L4.94067 13.4848C4.0992 14.3216 4.0992 15.6784 4.94067 16.5152L14.8218 26.3419C15.6632 27.1788 15.6632 28.5355 14.8218 29.3724Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowIcon);
export default __webpack_public_path__ + "static/media/back-arrow-icon.d911b1e57db8ef09339458f718df0a51.svg";
export { ForwardRef as ReactComponent };